import { Link } from "react-router-dom";
import style from "./styles/Footer.module.scss";
import paths from "../../../lib/paths";
import { type FC } from "react";

type Prop = {
    setOpenModal: (state: boolean) => void;
};
const Footer: FC<Prop> = ({ setOpenModal }) => {
    const currentYear = new Date().getFullYear();
    const copyrightNotice = `© Hytch Buddy ${currentYear}`;

    return (
        <div className={style.footer}>
            <div className="wrapper-constrain">
                <div className={style.footerRow1}>
                    <div className={style.footerLogoCol}>
                        <Link to="/">
                            <img
                                className={style.logo}
                                src={`${paths.icons}/logo.png`}
                                alt="hytchbuddy logo"
                            />
                        </Link>
                        <div className={style.footerPill}>Illinois, USA</div>
                        <select className={style.footerPill} name="" id="">
                            <option value="English">English</option>
                        </select>
                    </div>
                    <div className={style.footerRow1QuickLinks}>
                        <div className="">
                            <h3>Products</h3>
                            <ul>
                                <li>
                                    <Link to="/ride">
                                        <p>Ride</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/drive">
                                        <p>Drive</p>
                                    </Link>
                                </li>
                            </ul>
                        </div>
                        <div className="">
                            <h3>Support</h3>
                            <ul>
                                <li>
                                    <Link to="/safety">
                                        <p>Safety</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/support">
                                        <p>Help</p>
                                    </Link>
                                </li>
                                <li>
                                    <Link to="/faq">
                                        <p>FAQ</p>
                                    </Link>
                                </li>
                                <li onClick={() => setOpenModal(true)}>
                                    <p>Contact Us</p>
                                </li>
                            </ul>
                        </div>
                        <div className="">
                            <h3>Company</h3>
                            <ul>
                                <li>
                                    <Link to="/company">
                                        <p>About Us</p>
                                    </Link>
                                </li>
                                {/* <li>
                                      <Link
                                        onClick={() =>
                                          toast("Coming Soon!", {
                                            icon: "🛄",
                                          })
                                        }
                                        to="#"
                                      >
                                        <p>Cities</p>
                                      </Link>
                                    </li> */}
                                {/* <li>
                                      <Link
                                        onClick={() =>
                                          toast("Coming Soon!", {
                                            icon: "🛄",
                                          })
                                        }
                                        to="#"
                                      >
                                        <p>Blog</p>
                                      </Link>
                                    </li> */}
                                {/* <li>
                                      <Link
                                        onClick={() =>
                                          toast("Coming Soon!", {
                                            icon: "🛄",
                                          })
                                        }
                                        to="#"
                                      >
                                        <p>Career</p>
                                      </Link>
                            </li> */}
                            </ul>
                        </div>
                    </div>
                </div>
                <div className={style.mobilePilShapes}>
                    <div className={style.footerPill}>Illinois, USA</div>
                    <select className={style.footerPill} name="" id="">
                        <option value="English">English</option>
                    </select>
                </div>
                <div className={style.footerRow2}>
                    <a
                        href="https://www.linkedin.com/company/hytch-buddy/about/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className={style.logo}
                            src={`${paths.svgs}/linkedin.svg`}
                            alt="hytchbuddy logo"
                        />
                    </a>
                    <a
                        href="https://twitter.com/HytchBuddy"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className={style.logo}
                            src={`${paths.svgs}/x.svg`}
                            alt="hytchbuddy logo"
                        />
                    </a>
                    <a
                        href="https://www.instagram.com/hytchbuddy/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className={style.logo}
                            src={`${paths.svgs}/instagram.svg`}
                            alt="hytchbuddy logo"
                        />
                    </a>
                    <a
                        href="https://www.facebook.com/profile.php?id=61556280742237"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        <img
                            className={style.logo}
                            src={`${paths.svgs}/facebook.svg`}
                            alt="hytchbuddy logo"
                        />
                    </a>
                </div>
                <div className={style.footerRow3}>
                    <div className="">
                        <Link to="/">
                            <p>{copyrightNotice}</p>
                        </Link>
                    </div>
                    <div className="">
                        <Link to="/privacy-policy">
                            <p>Privacy</p>
                        </Link>
                        <Link to="/terms-and-conditions">
                            <p>Terms</p>
                        </Link>
                    </div>
                </div>
            </div>
        </div>
    );
};
export default Footer;
